import { useEffect, useRef } from 'react';

/**
 * Clears a dependent field's value whenever its parent's selection changes
 * (e.g. Domain must be cleared when Tenant changes). Does nothing on mount,
 * so an already-populated value isn't wiped out just because the effect ran
 * once with the initial parent value.
 */
export function useResetOnParentChange(
  parentKey: string | undefined,
  onChange: (value: undefined) => void,
): void {
  const previousParentKey = useRef(parentKey);

  useEffect(() => {
    if (previousParentKey.current !== parentKey) {
      onChange(undefined);
    }
    previousParentKey.current = parentKey;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentKey]);
}
